/* eslint-disable object-curly-newline,no-param-reassign */
import update from 'immutability-helper';

export const API_LOAD_SUBCONTRACTOR_STATS = 'API_LOAD_SUBCONTRACTOR_STATS';
const API_LOAD_SUBCONTRACTOR_STATS_FAILED = 'API_LOAD_SUBCONTRACTOR_STATS_FAILED';
const API_LOAD_SUBCONTRACTOR_STATS_LOADING = 'API_LOAD_SUBCONTRACTOR_STATS_LOADING';
const API_LOAD_SUBCONTRACTOR_STATS_LOADED = 'API_LOAD_SUBCONTRACTOR_STATS_LOADED';

const defaultState = { subContractorStats: [], loading: false };

const group = response => response.reduce(
  (map, obj) => {
    if (!map[obj.subcontractor.name]) map[obj.subcontractor.name] = {};
    if (!map[obj.subcontractor.name][obj.project.name]) map[obj.subcontractor.name][obj.project.name] = {};

    const date = new Date(obj.workorder.wo_date);
    const dateKey = `${date.getUTCMonth() + 1}/${date.getUTCDate()}`;

    if (map[obj.subcontractor.name][obj.project.name][dateKey] === undefined) {
      obj["hours"] = parseFloat(obj["hours"]);
      map[obj.subcontractor.name][obj.project.name][dateKey] = obj;
      map[obj.subcontractor.name][obj.project.name][dateKey]['workorders'] = [obj.workorder_id]
    } else {
      let hours = map[obj.subcontractor.name][obj.project.name][dateKey]['hours'];
      map[obj.subcontractor.name][obj.project.name][dateKey]['hours'] = hours + parseFloat(obj['hours']);
      map[obj.subcontractor.name][obj.project.name][dateKey]['workorders'].push(obj.workorder_id)
    }

    return map;
  },
  {},
);

export const reducer = (state = defaultState, { type, response }) => {
  switch (type) {
    case API_LOAD_SUBCONTRACTOR_STATS_LOADED:
      return update(state, {
        loading: { $set: false },
        subContractorStats: { $set: group(response) },
      });
    case API_LOAD_SUBCONTRACTOR_STATS_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_SUBCONTRACTOR_STATS_FAILED:
      return update(state, { loading: { $set: false } });
    default:
      return state;
  }
};

export const loading = state => state.subContractorStats.loading;
export const stats = state => state.subContractorStats.subContractorStats;


export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/subContractorStats/subContractorStats.reducer.js